import Modal from 'react-bootstrap/Modal'
import ModalHeader from 'react-bootstrap/ModalHeader'
import Fade from 'react-bootstrap/Fade'
import CloseButton from 'react-bootstrap/CloseButton'
import { restoreDefaultProps, restoreFindDOMNode } from '.'

// Modal renders `dialogAs` (from defaultProps) and animates with Fade.
restoreDefaultProps(Modal, ModalHeader, Fade, CloseButton)
restoreFindDOMNode()
